import { useId, useLayoutEffect, useRef, useState } from "react";

// Two native scroll rails share one horizontal position, including touch/keyboard input.
export const HorizontalScroll = ({ children, testId, className = "", contentClassName = "", ...props }) => {
  const id = useId();
  const prefix = testId || `horizontal-scroll-${id}`;
  const top = useRef(null), content = useRef(null), body = useRef(null);
  const [width, setWidth] = useState(0);
  const [overflow, setOverflow] = useState(false);
  useLayoutEffect(() => {
    const measure = () => {
      if (!content.current) return;
      setWidth(content.current.scrollWidth);
      setOverflow(content.current.scrollWidth > content.current.clientWidth + 1);
      if (top.current) top.current.scrollLeft = content.current.scrollLeft;
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(content.current);
    observer.observe(body.current);
    return () => observer.disconnect();
  }, [children]);
  const sync = (source, target) => {
    if (target.current && target.current.scrollLeft !== source.currentTarget.scrollLeft) target.current.scrollLeft = source.currentTarget.scrollLeft;
  };
  return <div className={`min-w-0 max-w-full ${className}`} data-testid={prefix} {...props}>
    <div ref={top} data-testid={`${prefix}-top-scroll`} aria-label="Scroll list horizontally" tabIndex={overflow ? 0 : -1} role="region" onScroll={(event) => sync(event, content)} className={`horizontal-scroll-rail overflow-x-auto overflow-y-hidden ${overflow ? "h-4" : "hidden"}`}>
      <div style={{ width, height: 1 }} aria-hidden="true" />
    </div>
    <div ref={content} data-testid={`${prefix}-scroll-content`} className="max-w-full overflow-auto" onScroll={(event) => sync(event, top)}>
      <div ref={body} className={`min-w-full ${contentClassName}`}>{children}</div>
    </div>
  </div>;
};
